import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';
import ACF from '../../../assets/background/ngo/spa.webp';
import PU from '../../../assets/background/ngo/forest.webp';
import UEPM from '../../../assets/background/ngo/child.webp';

const style = () =>
  createStyles({
    card: {
      '@media (min-width: 1280px)': {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0
      },
      display: 'flex',
      gap: '10px',
      flexDirection: 'column',
      borderRadius: palette.borderRadius.default,
      backgroundColor: palette.background.box,
      overflow: 'hidden',
      boxShadow: palette.shadows.boxShadow,
      justifyContent: 'space-between'
    },
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px 0'
    },
    image: {
      width: '100%',
      height: '200px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: palette.text.white,
      '& > h1': {
        fontSize: '2rem',
        textAlign: 'center',
        padding: '20px'
      }
    },
    Planete_urgence: {
      backgroundImage: `linear-gradient(180deg, rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0) 100%), url(${PU})`,
      backgroundSize: 'cover'
    },
    Un_enfant_par_la_main: {
      backgroundImage: `linear-gradient(180deg, rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0) 100%), url(${UEPM})`,
      backgroundSize: 'cover'
    },
    Societe_protectrice_des_animaux: {
      backgroundImage: `linear-gradient(180deg, rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0) 100%), url(${ACF})`,
      backgroundSize: 'cover',
      '@media (max-width: 1280px)': {
        backgroundPosition: '0px -200px'
      }
    },
    content: {
      backgroundColor: palette.background.box,
      marginTop: '-10px',
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      justifyContent: 'space-between',
      padding: '20px'
    },
    contentText: {
      display: 'flex',
      flexDirection: 'column',
      gap: '25px'
    },
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    catchPhrase: {
      fontWeight: 600,
      border: '1px solid #e2e8f0',
      padding: '10px',
      borderRadius: '10px'
    },
    video: {
      overflow: 'hidden',
      paddingBottom: '56.25%',
      position: 'relative',
      height: 0,
      backgroundColor: '#ccc'
    },
    iframe: {
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
      position: 'absolute'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
